<template>
  <div class="suboptions">
    <input
      v-model="searchTerm"
      type="text"
      class="mar-5"
      :placeholder="`Search by ${option.name}`"
    />
    <simplebar
      class="list-wrapper"
      data-auto-hide="false"
      scrollbarMaxSize="30"
    >
      <div
        :class="[
          'option',
          {
            active:
              selectedFilters.filter(
                (filter) => filter.value === suboption.name
              ).length > 0,
          },
        ]"
        v-for="suboption in filteredSuboptions"
        :key="suboption.id"
        @click="selectItem(option, suboption)"
      >
        <p class="ellipsis">{{ suboption.name }}</p>
      </div>
      <div v-if="filteredSuboptions.length == 0" class="option no-results">
        No options
      </div>
    </simplebar>
  </div>
</template>

<script>
export default {
  props: {
    option: Object,
    suboptions: Array,
    selectedFilters: Array,
  },
  data() {
    return {
      searchTerm: "",
    };
  },
  computed: {
    filteredSuboptions() {
      const regex = new RegExp(this.searchTerm, "i");
      return this.suboptions
        .filter((item) => regex.test(item.name))
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
        .sort((a, b) =>
          a.description && b.description
            ? a.description > b.description
              ? 1
              : b.description > a.description
              ? -1
              : 0
            : 0
        );
    },
  },
  methods: {
    selectItem(option, suboption) {
      this.$emit("onFilterSelected", {
        colname: option.id,
        comparison: "=",
        value: suboption.name,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.no-results {
  cursor: default !important;
  justify-content: center !important;

  &:hover {
    background: var(--color-secondary) !important;
  }
}
</style>
